import { render, staticRenderFns } from "./SelectReportTypeMenu.vue?vue&type=template&id=1f37bbfc&"
import script from "./SelectReportTypeMenu.vue?vue&type=script&lang=js&"
export * from "./SelectReportTypeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports